export default function Cta() {
  return (
    <section className="relative overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Wide%20abstract%20panorama%20of%20a%20clean%20future%20steel%20city%20at%20sunrise%20with%20green%20energy%20light%20streams%20and%20soft%20amber%20glow%2C%20minimal%20artistic%20industrial%20render%2C%20deep%20green%20tones%2C%20high%20detail&width=1920&height=760&seq=gs-cta-band&orientation=landscape"
          alt="Green steel supporting a sustainable future skyline"
          title="Sustainable green steel for future infrastructure"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-primary-950/90 via-primary-950/75 to-foreground-950/60" />
      </div>

      <div className="relative mx-auto w-full max-w-7xl px-4 py-20 md:px-6 md:py-24 lg:px-10">
        <div className="max-w-2xl">
          <h2 className="reveal font-heading text-3xl font-semibold leading-tight text-background-50 md:text-4xl lg:text-5xl">
            See the plant working before it is built
          </h2>
          <p className="reveal mt-5 text-base leading-relaxed text-background-200 md:text-lg">
            We built a 1.8 m tabletop model and an identical interactive 3D twin. Walk the plant, switch to night,
            and watch hydrogen flow from electrolyser to shaft furnace — then talk to us about early offtake.
          </p>
          <div className="reveal mt-8 flex flex-col gap-3 sm:flex-row">
            <a
              href="#contact"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md bg-accent-500 px-6 py-3.5 text-sm font-semibold text-primary-950 transition-colors hover:bg-accent-400"
            >
              Talk to our team
              <i className="ri-arrow-right-line" />
            </a>
            <a
              href="#numbers"
              className="inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/30 px-6 py-3.5 text-sm font-semibold text-background-50 backdrop-blur transition-colors hover:bg-background-50/10"
            >
              See the numbers
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}